/** @format */

import { ReviewFilter, SelectedTagDistributionInformationFrequency } from '../../model';
import { createAction, props } from '@ngrx/store';

/**
 * Action types initialization
 */
export enum ProductReviewFilterActionTypes {
	ADD_MULTIPLE_REVIEW_FILTERS = '[Product Reviews Filter] Add Multiple Review Filters',
	ADD_RATING_FILTER = '[Product Reviews Filter] Add Rating Filter',
	ADD_REVIEW_FILTER = '[Product Reviews Filter] Add Review Filter',
	ADD_SEARCH_FILTER = '[Product Reviews Filter] Add Search Filter',
	ADD_SELECTED_TAG = '[Product Reviews Filter] Add Selected Tag',
	ADD_SORT_FILTER = '[Product Reviews Filter] Add Sort Filter',
	CLEAN_REVIEW_FILTER = '[Product Reviews Filter] Clean Review Filters',
	CLEAN_REVIEW_FILTER_RATINGS = '[Product Reviews Filter] Clean Review Filter Ratings',
	CLEAN_SELECTED_TAG = '[Product Reviews Filter] Clean Selected Tag',
	REMOVE_REVIEW_FILTER = '[Product Reviews Filter] Remove Review Filter',
	REMOVE_SEARCH_FILTER = '[Product Reviews Filter] Remove Search Filter',
	REMOVE_SELECTED_TAG = '[Product Reviews Filter] Remove Selected Tag',
	REMOVE_SORT_FILTER = '[Product Reviews Filter] Remove Sort Filter'
}

/**
 * Actions initialization
 */

/* Review Selected Tag Actions */
export const addSelectedTag = createAction(
	ProductReviewFilterActionTypes.ADD_SELECTED_TAG,
	props<{ selectedTag: SelectedTagDistributionInformationFrequency }>()
);

export const removeSelectedTag = createAction(
	ProductReviewFilterActionTypes.REMOVE_SELECTED_TAG,
	props<{ tagId: string }>()
);

export const cleanSelectedTag = createAction(ProductReviewFilterActionTypes.CLEAN_SELECTED_TAG);

/* Review Filter Actions */
export const addReviewFilter = createAction(
	ProductReviewFilterActionTypes.ADD_REVIEW_FILTER,
	props<{ filter: ReviewFilter }>()
);

export const removeReviewFilter = createAction(
	ProductReviewFilterActionTypes.REMOVE_REVIEW_FILTER,
	props<{ filterId: string }>()
);

export const cleanReviewFilterRatings = createAction(ProductReviewFilterActionTypes.CLEAN_REVIEW_FILTER_RATINGS);

export const addMultipleReviewFilters = createAction(
	ProductReviewFilterActionTypes.ADD_MULTIPLE_REVIEW_FILTERS,
	props<{ filters: ReviewFilter[] }>()
);

export const cleanReviewFilters = createAction(ProductReviewFilterActionTypes.CLEAN_REVIEW_FILTER);

/* Review Search Actions */
export const addSearchFilter = createAction(
	ProductReviewFilterActionTypes.ADD_SEARCH_FILTER,
	props<{ search: string }>()
);

export const removeSearchFilter = createAction(ProductReviewFilterActionTypes.REMOVE_SEARCH_FILTER);

/* Review Sort Actions */
export const addSortFilter = createAction(
	ProductReviewFilterActionTypes.ADD_SORT_FILTER,
	props<{ sort: ReviewFilter }>()
);

export const removeSortFilter = createAction(ProductReviewFilterActionTypes.REMOVE_SORT_FILTER);

export const setRatingFilter = createAction(
	ProductReviewFilterActionTypes.ADD_RATING_FILTER,
	props<{
	  rating: {
		key: string;
		label: string;
		selected: boolean
	  }
	}>()
);
